import { z } from "zod/v4";

export const CleanupGaResponseBodySchema = z.string();
export type CleanupGaResponseBodyType = z.infer<
  typeof CleanupGaResponseBodySchema
>;
